import "@fontsource/montserrat";
import "@fontsource/montserrat/900-italic.css";
import "@fontsource/montserrat/900.css";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import About from "./components/About";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import theme from "./theme";

function App() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <Hero />
      <main>
        <About />
        <Projects />
      </main>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
